<template>
  <v-container class="home" fluid>
        <div class="one">
            <h2><u>About this website</u></h2>
    <p>This website is an important step in sharing information with our neighbors, providing communities with:</p>
    <ul>
      <li>A map showing the location of each monitor and other relevant topographical information including any nearby water bodies, roadways and adjacent land uses.</li>
      <li>A table showing the information for each monitor for the calendar year which is provided in a manner that can be understood by those without specialized scientific training.</li>
      <li>Data for each site being monitored is updated no later than two weeks after a biweekly air sample is collected.</li>
    </ul><s></s>
    
    <br/>

    <h2><u>What is fenceline monitoring?</u></h2>
    <p>Fenceline (or perimeter) monitoring is the use of monitoring technology to measure the ambient air concentration of a specific chemical at the property line of a manufacturing site (e.g., petroleum refinery, chemical plant).
    </p>

    <p>The United States Environmental Protection Agency ("US EPA") promoted fenceline monitoring as an appropriate method for an open and transparent evaluation of a site’s emissions monitoring and control methods on an on-going basis.
    </p>

    <p>To achieve that goal, the US EPA developed this work practice and published it in December 2015. This work practice specified the monitoring technology to be used, an implementation approach, and a benzene fenceline concentration action level. Concentrations above stated levels requires owners or operators to implement corrective action to reduce their fenceline concentration to below this action level. The details of the fenceline monitoring work practice are prescribed in EPA Test Methods 325A and 325B which LyondellBasell uses.
    </p>

    <p>This is the work practice that LyondellBasell uses for our fenceline monitoring programs. 
    </p>
    
    <br/>

    <h2><u>How it works</u></h2>
    <p>The air samples are collected by tubes, which are filled with an absorbent and switched out every two weeks. Once removed, the tubes are sampled at an independent accredited laboratory.
    </p>
    </div>
    <div class="two">
        <h1 class="text-center blackText">{{ PlantFullName }} ({{plantCode.toUpperCase()}})</h1>
        <v-img
          :alt="plantCode"
          :src="'data:image/jpeg;base64,' + imageBase64"
          contain
          class="site-img"
        >
        
    <template v-slot:placeholder>
            <v-skeleton-loader
              :v-if="pageloading"
              :loading="pageloading"
              type="image"
              class="skeleton-img"
              height="100%"
            ></v-skeleton-loader>
          </template>
        </v-img>
    <v-spacer></v-spacer>
        <div class="sub_div">
        <v-btn align="center"
          class="btnCurrentPDF"
          :loading="fileloadingPDF"
          :disabled="fileloadingPDF"
          color="gray"
          @click="getPDFFile"
        >
          {{"Current Data Report"}}
        </v-btn>
           <!--<v-btn float="left"
          :loading="fileloadingImg"
          :disabled="fileloadingImg"
          color="gray"
          @click="getImageFile"
        >
        {{"Full Image"}}
        </v-btn>-->
        </div>
    </div>
  </v-container>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
import axios from "axios";
export default {
  name: "Site",
  data: () => ({
    imageBase64: "",
    fileloadingPDF: false,
    fileloadingImg: false,
    pageloading: true,
    imageBlob: null,
    getPDFUrl: "",
    getImageUrlJpg: "",
    getImageUrlPng: "",
    imageType: "",
    PlantFullName: "",
    CurrentURL: ""
  }),
  metaInfo() {
    var description = "";

    if(this.plantCode.toUpperCase() == "CVO")
    {
      description = "Fenceline Monitoring, Benzene, LyondellBasell, Channelview, 8280 Sheldon Road, Texas Butadiene and Chemical Corporation, Equistar Chemicals";
    }
    else if (this.plantCode.toUpperCase() == "CCO")
    {
      description = "Fenceline Monitoring, Benzene, LyondellBasell, Corpus Christi, 1501 McKinzi Road";
    }
    else if (this.plantCode.toUpperCase() == "CLO")
    {
      description = "Fenceline Monitoring, Benzene, LyondellBasell, Clinton, Equistar Chemicals, 3400 Anamosa Road";
    }
    else if (this.plantCode.toUpperCase() == "LPO")
    {
      description = "Fenceline Monitoring, Benzene, LyondellBasell, La Porte, Equistar Chemicals, LyondellBasell Acetyls, 1515 Miller Cut-Off Road, 1350 Miller Cut-Off Road";
    }
    else if (this.plantCode.toUpperCase() == "MIO")
    {
      description = "Fenceline Monitoring, Benzene, LyondellBasell, Morris, Equistar Chemicals, 8805 N Tabler Road";
    }
    var urlModified = this.CurrentURL.split('#')[0];
    console.log("urlModified: " + urlModified);
        return { 
            title: `LyondellBasell - Fenceline monitoring ${this.PlantFullName} (${this.plantCode.toUpperCase()})`,
            meta: [
                { name: 'description', content:  description},
                { property: 'og:title', content: `LyondellBasell - Fenceline monitoring ${this.PlantFullName} (${this.plantCode.toUpperCase()})` },
                { property: 'og:site_name', content: `LyondellBasell - Fenceline monitoring ${this.PlantFullName} (${this.plantCode.toUpperCase()})`},
                {property: 'og:type', content: 'website'},
                {property: 'og:url', content: urlModified},
                {name: 'robots', content: 'index,follow'},
                {name: 'keywords', content: description}
            ]
        }
    },
  params: ["siteobj"],
  mixins: [uiView, appMixin],
  components: {  },
  props: {},
  watch: {
    plantCode: function() {
      this.imageBase64 = "";
      this.pageloading = true;
      this.getImage();
    },
  },
  beforeMount(){

  },
  mounted() {
    this.getImage();
  },
  computed: {
    plantCode() {
      //debugger;
      //return this.$route.params.code;
      this.CurrentURL = window.location.href;

      //this.CurrentURL = "https://cvo-dev.fencelinemonitoring.lyondellbasell.com/#/Report";
      //this.CurrentURL = "https://cvo-stg.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://cvo.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://clo-dev.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://clo-stg.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://clo.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://cco-dev.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://cco-stg.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://cco.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://lpo-dev.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://lpo-stg.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://lpo.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://mio-dev.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://mio-stg.fencelinemonitoring.lyondellbasell.com";
      //this.CurrentURL = "https://mio.fencelinemonitoring.lyondellbasell.com";
      var siteTemp = this.CurrentURL.split('://')[1].split('/')[0].split('.')[0];
      var site = siteTemp;
      if(siteTemp.includes("dev"))
      {
        site = siteTemp.replace("-dev", "");
      }
      else if(siteTemp.includes("stg"))
      {
        site = siteTemp.replace("-stg", "");
      }
      debugger;
      //var site = this.CurrentURL.substring(this.CurrentURL.lastIndexOf('/') + 1);
      this.getPDFUrl = this.settings.azureAPIMUrl + "?spPath=Shared Documents/" + site + "/" + site + ".pdf";
      //console.log(this.getPDFUrl);
      this.getImageUrlJpg = this.settings.azureAPIMUrl + "?spPath=Shared Documents/" + site + "/" + site + ".jpg";
      //console.log(this.getImageUrlJpg);
      this.getImageUrlPng = this.settings.azureAPIMUrl + "?spPath=Shared Documents/" + site + "/" + site + ".png";
      //console.log(this.getImageUrlPng);
      if(site.toUpperCase() == "CCO"){this.PlantFullName = "Corpus Christi Plant";}
      else if (site.toUpperCase() == "CVO"){this.PlantFullName = "Channelview Plants";}
      else if (site.toUpperCase() == "CLO"){this.PlantFullName = "Clinton Plant";}
      else if (site.toUpperCase() == "LPO"){this.PlantFullName = "La Porte Plants";}
      else if (site.toUpperCase() == "MIO"){this.PlantFullName = "Morris Plant";}

      
      return site;
    }
  },  
  methods: {
    convertBase64ToBlob(base64){
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'application/pdf'});
      this.imageBlob = blob;
    },
    getImage() {
      //debugger;
      let existingImg = this.Fenceline_images.find((obj) => {
        return obj.id === this.plantCode;
      });

      if (existingImg) {
        this.imageBase64 = existingImg.image;
        this.pageloading = false;
      } else {
        //axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        let self = this;
        // get jpg
        axios
          .get(
            this.getImageUrlJpg
          )
          .then((response) => {
            debugger;
            self.imageBase64 = response.data;
            self.pageloading = false;
            self.Fenceline_images.push({ id: self.plantCode, image: self.imageBase64 });
            this.imageType = "jpg";
          })
          .catch((error) => {
            // get png if jpg does not exist
           axios
          .get(
            this.getImageUrlPng
          )
          .then((response) => {
            debugger;
            self.imageBase64 = response.data;
            self.pageloading = false;
            self.Fenceline_images.push({ id: self.plantCode, image: self.imageBase64 });
            this.imageType = "png";
          })
          .catch((error) => {
            console.log(error)
          });

          });
      }
    },
   async getPDFFile() {
      this.fileloadingPDF = true;
      //axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      let self = this;
        //self.fileloading = false;
        /*var file = new Blob([this.imageBlob], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");*/
      await axios({
        //url: this.settings.azureAPIMUrl + "&method=getFile&site=" + this.plantCode,
        url: this.getPDFUrl,
        method: "GET",
        //responseType: "blob",
      }).then((response) => {
        self.fileloadingPDF = false;
        this.convertBase64ToBlob(response.data);
        debugger;
        var file = new Blob([this.imageBlob], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");
      });
    },
    async getImageFile() {
      this.fileloadingImg = true;
      let self = this;
      var _type = "";
      var _imgURL = "";
      if(this.imageType == "jpg"){_type = "image/jpeg"; _imgURL=this.getImageUrlJpg;}
      else if(this.imageType == "png"){_type = "image/png"; _imgURL=this.getImageUrlPng;}
      console.log("image type: " + this.imageType);
      await axios({
        //url: this.settings.azureAPIMUrl + "&method=getFile&site=" + this.plantCode,
        url: _imgURL,
        method: "GET",
        //responseType: "blob",
      }).then((response) => {
        self.fileloadingImg = false;
        this.convertBase64ToBlob(response.data);
        debugger;
        var file = new Blob([this.imageBlob], { type: _type });
        var fileURL = URL.createObjectURL(file);
        console.log(fileURL);
        window.open(fileURL, "_blank");
      });
    },
  },
};
</script>
<style lang="scss">
  .site-img {
    /*height: 60vh;*/
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
    padding-top: 3%;
    width: 80%;
    /*width: 1200px;
    height: 864px;*/
    //width: 100%;
    }
  .skeleton-img {
    padding-left: 10%;
    padding-right: 10%;
    background-size: contain;
    height: 100%;
  }
  .blackText {
    color: black !important;
    margin-top: 5%;
  }
  .one {
    padding-top:5%;
    padding-left: 5%;
    width: 35%;
    float: left;
  }

  .two {
    margin-top: 5%;
    padding-left: 45%;
    height: 30%;
    //position: absolute;
  }
  
  .sub_div {
    text-align: center;
  }

  .btnCurrentPDF{
    margin-right:5px;
  }

</style>
